import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerPlusApi } from '~/api/client'
import { GENERAL_QUERY_KEYS } from '~/constants/query-keys/general.constant'
import { BannerModel } from '~/types/model/general/banner.model'
import { SearchModel } from '~/types/model/general/search.model'
import { SocialModel } from '~/types/model/general/social.model'
import { HomeBannerModel } from '~/types/model/home/banner.model'
import { CHomeExplorer } from '~/types/model/home/home-explorer.model'
import { searchFilterType } from '~/types/search-filter.type'

export const useGeneralSocialInfo = (types: string[]) => {
  return useQuery([ ...GENERAL_QUERY_KEYS.SOCIAL ], async () => {
    return explorerPlusApi.generalController.getGeneralSocialInfo({
      types: types.join(','),
    }).then(res => res.flagGeneralSocialInfo?.OBJ.slice(0, 4).map(social => new SocialModel(social.CH, social.SOCTP, social.LNK)))
  })
}

export const useSearchHandler = (term: Ref<string>, filterBy: searchFilterType = searchFilterType.ALL, isEnable: Ref<boolean>) => {
  return useQuery([ ...GENERAL_QUERY_KEYS.SEARCH, term, filterBy ], async () => {
    return explorerPlusApi.generalController.getSearchHandler({
      term: term.value,
      filterBy,
    }).then(res => {
      return new SearchModel(res)
    })
  }, {
    enabled: isEnable,
  })
}

export const useBannerInfo = () => {
  return useQuery([ ...GENERAL_QUERY_KEYS.BANNER ], async () => {
    return explorerPlusApi.generalController.getBannerInfo().then(res => {
      return res.map(banner => new BannerModel(banner))
    })
  })
}

export const useGeneralExplorer = () => {
  return useQuery([ ...GENERAL_QUERY_KEYS.EXPLORER ], async () => {
    return explorerPlusApi.generalController.getSearchHandler1()
      .then(res => {
        return new CHomeExplorer(res, 'Transfer')
      })
  })
}

export const useGetHomeBannerList = () => {
  return useQuery([ ...GENERAL_QUERY_KEYS.HOME_BANNER ], async () => {
    return explorerPlusApi.generalController.getHomeBannerList().then(res => {
      return res.map(banner => new HomeBannerModel(banner))
    })
  })
}